module.exports = __webpack_public_path__ + "static/img/y30.b51260a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/images/y30.jpg
// module id = GmuX
// module chunks = 1